var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "hotkeys",
          attrs: { id: "hotkeysGuide", tabindex: "0" },
        },
        [_c("fa", { attrs: { icon: ["fas", "lightbulb"], size: "sm" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tooltip",
        {
          attrs: {
            target: "hotkeysGuide",
            triggers: "click blur",
            placement: "topleft",
            "custom-class": "hotkeys-tooltip",
          },
        },
        [
          _c("div", { staticClass: "hk" }, [
            _c("div", { staticClass: "hk__header" }, [
              _c(
                "div",
                { staticClass: "hk__header-badge" },
                [_c("fa", { attrs: { icon: ["fas", "keyboard"] } })],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "hk__header-text" }, [
                _c("span", { staticClass: "hk__header-title" }, [
                  _vm._v("Hotkeys Guide"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "hk__header-sub" }, [
                  _vm._v("Keyboard & mouse shortcuts"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "hk__body" },
              _vm._l(_vm.groups, function (group, gIndex) {
                return _c(
                  "div",
                  { key: gIndex, staticClass: "hk__group" },
                  [
                    _c(
                      "div",
                      { staticClass: "hk__group-label" },
                      [
                        _c("fa", {
                          staticClass: "hk__group-icon",
                          attrs: { icon: ["fas", group.icon] },
                        }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(group.label) +
                            "\n                    "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(group.items, function (item, index) {
                      return _c("div", { key: index, staticClass: "hk__row" }, [
                        _c(
                          "div",
                          { staticClass: "hk__keys" },
                          [
                            _vm._l(item.keys, function (key, kIndex) {
                              return [
                                key.sep
                                  ? _c(
                                      "span",
                                      {
                                        key: "sep-" + kIndex,
                                        staticClass: "hk__sep",
                                      },
                                      [_vm._v(_vm._s(key.sep))]
                                    )
                                  : _c(
                                      "kbd",
                                      {
                                        key: "key-" + kIndex,
                                        staticClass: "hk__key",
                                        class: { "hk__key--wide": key.wide },
                                      },
                                      [_vm._v(_vm._s(key.label))]
                                    ),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "hk__desc" }, [
                          _vm._v(_vm._s(item.desc)),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }